<form nz-form nzLayout="vertical" [formGroup]="form">
  <div nz-row [nzGutter]="5">
    <div nz-col [nzSpan]="24">
      @if (appointmentProduct) {
        <beautyapp-input
          [ngModel]="appointmentProduct?.product?.name || appointmentProduct?.productName"
          [ngModelOptions]="{standalone: true}"
          [readonly]="true"
          />
      } @else {
        <beautyapp-select-search
          formControlName="productId"
          [data]="products"
          [placeholder]="'calendar.form.product' | translate"
          (onSearch)="searchProduct($event)"
          (ngModelChange)="selected($event)"
          valueMember="id"
          displayMember="name"
        ></beautyapp-select-search>
      }
    </div>

    <!-- Nothing below can be answered before a product is chosen: the unit,
         the stock on hand and the price all come from the product itself. -->
    @if (product) {
      <div nz-col [nzSpan]="24">
        <p class="stock" [class.stock--short]="exceedsStock">
          {{ 'calendar.form.inStock' | translate }}:
          <strong>{{ product.quantity || 0 }} {{ 'calendar.form.piece' | translate }}</strong>
          @if (gramTracked) {
            <span>
              ({{ product.grSum || 0 }} {{ 'calendar.form.gram' | translate }},
              {{ product.grPerItem }} {{ 'calendar.form.gram' | translate }} /
              {{ 'calendar.form.piece' | translate }})
            </span>
          }
        </p>
      </div>

      <div nz-col [nzSpan]="gramTracked ? 8 : 12">
        <beautyapp-input
          [label]="(unit === 'piece' ? 'calendar.form.piece' : 'calendar.form.gram') | translate"
          type="number"
          [(ngModel)]="amount"
          (ngModelChange)="amountChanged()"
          [ngModelOptions]="{ standalone: true }"
        ></beautyapp-input>
      </div>

      @if (gramTracked) {
        <div nz-col [nzSpan]="8">
          <div class="segmented-label">{{ 'calendar.form.unit' | translate }}</div>
          <nz-segmented
            [nzOptions]="unitOptions"
            [nzBlock]="true"
            nzSize="large"
            [(ngModel)]="unit"
            (ngModelChange)="amountChanged()"
            [ngModelOptions]="{ standalone: true }"
          ></nz-segmented>
        </div>
      }

      <div nz-col [nzSpan]="gramTracked ? 8 : 12">
        <beautyapp-input
          label="{{'calendar.form.price' | translate}}"
          placeholder="{{'calendar.form.gel' | translate}}"
          type="number"
          prefixIcon="dollar"
          formControlName="price"
        ></beautyapp-input>
      </div>

      <!-- Both readings of the same amount, so the operator can see what the
           unit switch actually means before saving. -->
      @if (gramTracked && unit === 'piece' && amount) {
        <div nz-col [nzSpan]="24">
          <p class="will-use">
            {{ 'calendar.form.willUse' | translate }}:
            <strong>{{ gramsUsed }} {{ 'calendar.form.gram' | translate }}</strong>
          </p>
        </div>
      }
    }
  </div>
</form>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="modal.close()">{{'buttons.close' | translate}}</button>
  <button nz-button nzType="primary" (click)="submit()" [disabled]="form.invalid">{{'buttons.save' | translate}}</button>
</div>
